import { createFileRoute } from "@tanstack/react-router";
import { ProductAnalyticsErrorDetailPage } from "../../../../components/system/ProductAnalyticsErrorDetailPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/product-analytics/errors/$errorId/")({
  beforeLoad: requireSuperAdmin(),
  component: ErrorDetailRoute,
});

function ErrorDetailRoute() {
  const { errorId } = Route.useParams();
  return <ProductAnalyticsErrorDetailPage errorId={errorId} />;
}
